import Siema from 'siema';

// extend a Siema class by two methods
// addDots - to create a markup for dots
// updateDots - to update classes on dots on change callback
class SiemaWithDots extends Siema {

    addDots() {
        // create a contnier for all dots
        // add a class 'dots' for styling reason
        this.dots = document.createElement('div');
        this.dots.classList.add('dots');
        const count = Math.round(this.innerElements.length / this.perPage);
        console.log(count);

        // loop through slides to create a number of dots
        for (let i = 0; i < count; i++) {
            // create a dot
            const dot = document.createElement('a');

            // add a class to dot
            dot.classList.add('dots__item');

            // add an event handler to each of them
            dot.addEventListener('click', () => {
                this.goTo(i * this.perPage);
            });

            // append dot to a container for all of them
            this.dots.appendChild(dot);
        }

        // add the container full of dots after selector
        this.selector.parentNode.insertBefore(this.dots, this.selector.nextSibling);
    }

    updateDots() {
        // loop through all dots
        for (let i = 0; i < this.dots.querySelectorAll('a').length; i++) {
            // if current dot matches currentSlide prop, add a class to it, remove otherwise
            const addOrRemove = this.currentSlide === i ? 'add' : 'remove';
            this.dots.querySelectorAll('a')[i].classList[addOrRemove]('dots__item--active');
        }
    }
}

const heroSlider = document.querySelector('.hero__slider');
if(heroSlider) {
    let slider = new Siema({
        selector: '.hero__slider',
        duration: 400,
        easing: 'ease-out',
        perPage: 1,
        startIndex: 0,
        draggable: true,
        multipleDrag: true,
        threshold: 20,
        loop: true,
    });
    // autoplay
    setInterval(() => slider.next(), 4000);
}

const brandsSlider = document.querySelector('.brands__slider');
if (brandsSlider) {
    let slider = new SiemaWithDots ({
        selector: '.brands__slider',
        duration: 400,
        easing: 'ease-out',
        perPage: {
            0: 2,
            640: 3,
            1024: 4
        },
        startIndex: 0,
        draggable: true,
        multipleDrag: true,
        threshold: 20,
        loop: true,
        onInit: function () {
            this.addDots();
            this.updateDots();
        },
        onChange: function () {
            this.updateDots();
        }
    });
    setInterval(() => slider.next(), 3000);
}

const testimonialsSlider = document.querySelector('.brands__slider');
if (testimonialsSlider) {
    let slider = new SiemaWithDots({
        selector: '.testimonials__slider',
        duration: 400,
        easing: 'ease-out',
        perPage: 1,
        startIndex: 0,
        draggable: true,
        multipleDrag: true,
        threshold: 20,
        loop: true,
        onInit: function () {
            this.addDots();
            this.updateDots();
        },
        onChange: function () {
            this.updateDots();
        }    
    });
    setInterval(() => slider.next(), 4000);
}


// WEBPACK FOOTER //
// ./js/modules/sliders.js